export default {
  SET_IS_INITIAL(state, data) {
    state.isInitial = data;
  },

  SET_PLAYBACK_SETTINGS(state, data) {
    state.playbackSettings = data;
  },

  SET_IS_ACTIVE_DATE_INPUT_DIALOG(state, data) {
    state.isActiveDateInputDialog = data;
  },

  SET_PLAYBACK_TIME_NOW(state, data) {
    state.playbackSettings.now = data;
  },

  SET_RG_PLAYBACK_STATUS(state, data) {
    state.playbackSettings.playbackStatus = data;
  },

  SET_PLAYBACK_SECONDS_PER_FRAME(state, data) {
    state.playbackSettings.secondsPerFrame = data;
  },

  SET_RG_PLAYBACK_OBJECTS(state, data) {
    state.rgPlaybackObjects = data;
  },

  SET_LAYER_FILTERS(state, data) {
    state.layerFilters = data;
  },

  SET_VISIBLE_TRACKS(state, data) {
    state.visibleTracks = data;
  },

  SET_PLAYBACK_REQUEST_SETTINGS(state, data) {
    state.playbackSettings = data;
  },

  RESET_VISIBLE_TRACKS(state) {
    state.visibleTracks = {
      vessels: [],
    };
  },

  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
